import { createReducer, on } from "@ngrx/store"
import { ChannelState } from "./channel.models"
import * as ChannelActions from "./channel.actions"
import * as UserActions from "../user/user.actions"

export const initialState: ChannelState = {
  data: null,
  allData: null,
  error: null,
  message: null,
  success: false,
  validationError: []
}

export const channelReducer = createReducer(
  initialState,

  on(ChannelActions.ChannelCreateSuccess, (state) => ({
    ...state,
    error: null,
    message: "Channel created successfully",
    success: true,
    validationError: []
  })),

  on(ChannelActions.ChannelCreateFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(ChannelActions.ChannelValidatoionError, (state, { validationError }) => ({
    ...state,
    error: null,
    message: null,
    success: false,
    validationError
  })),

  on(ChannelActions.ChannelFetchSuccess, (state, { channels }) => ({
    ...state,
    allData: channels,
    error: null,
    message: "Channels fetched successfully",
    success: true,
    validationError: []
  })),

  on(ChannelActions.ChannelFetchFailure, (state, { error }) => ({
    ...state,
    allData: null,
    error,
    message: null,
    success: false,
    validationError: []
  })),

    on(ChannelActions.ChannelMarkMessagesReadSuccess, (state, { message }) => ({
    ...state,
    error: null,
    message,
    success: true,
    validationError: []
  })),

    on(ChannelActions.ChannelMarkMessagesReadFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(ChannelActions.ChannelLeaveSuccess, (state, { channelId, message }) => ({
    ...state,
    allData: state.allData?.filter((channel) => (channel.channel_id || channel.id) !== channelId) ?? state.allData,
    error: null,
    message,
    success: true,
    validationError: []
  })),

  on(ChannelActions.ChannelLeaveFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(ChannelActions.ChannelAddParticipantSuccess, (state, { message }) => ({
    ...state,
    error: null,
    message,
    success: true,
    validationError: []
  })),

  on(ChannelActions.ChannelAddParticipantFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(ChannelActions.ChannelRenameSuccess, (state, { channel, message }) => ({
    ...state,
    allData: state.allData?.map((item) =>
      (item.channel_id || item.id) === (channel.channel_id || channel.id) ? channel : item
    ) ?? state.allData,
    error: null,
    message,
    success: true,
    validationError: []
  })),

  on(ChannelActions.ChannelRenameFailure, (state, { error }) => ({
    ...state,
    error,
    message: null,
    success: false,
    validationError: []
  })),

  on(UserActions.UserProfilePatched, (state, { user }) => ({
    ...state,
    allData: state.allData?.map((channel) => ({
      ...channel,
      channel_participants: channel.channel_participants.map((participant) =>
        participant.user_id === user.id
          ? {
              ...participant,
              name: user.name,
            }
          : participant
      ),
    })) ?? state.allData,
  })),
)
